<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        시스템 패턴
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">시스템 패턴</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detatil_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">등록일</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_is_alive">활성화 상태</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['is_alive']" @change="refresh">
              <option disabled value="">활성화 상태를 선택하세요</option>
              <option value='true'>활성화</option>
              <option value='false'>비활성화</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_type">분류</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" label="Category" v-model="so.opt['category']">
              <option value="1">Unclassified</option>
              <option value="2">WebShell</option>
              <option value="3">SpamMail</option>
              <option value="4">FileManager</option>
              <option value="5">RansomeWare</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_ext">확장자</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" label="ext" v-model="so.opt['ext']">
              <option value="1">Uncategorized</option>
              <option value="2">CGI Executable file</option>
              <option value="3">JSP/WAR</option>
              <option value="4">NodeJS</option>
              <option value="5">ASP/ASPX</option>
              <option value="6">PHP</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_type">타입</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" label="Type" v-model="so.opt['type']">
              <option value="1">Regex</option>
              <option value="2">SSDEEP</option>
              <option value="3">Hash(MD5)</option>
              <option value="4">URL</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 aign-self-center mt-3">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detatil_search -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
        <span class="badge badge_border_primary mb-2">Regex : <span style="padding-left: 3.4rem"></span>{{model.R.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">SSDEEP : <span style="padding-left: 1.8rem"></span>{{model.S.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">Hash(MD5) : <span style="padding-left: 0.5rem"></span>{{model.M.toString().padStart(6, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_success mb-2">URL : <span style="padding-left: 3.3rem"></span>{{model.U.toString().padStart(6, nbsp) | number}}</span>
      </b-col>
      
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
          <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '코드'" v-model="so.sk">
              <option disabled value="">검색</option>
              <option value="code">코드</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
              <b-checkbox @change="refresh" class="ml-3 mt-2" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
            </div>
          <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" v-if="enable_new !== false" size="sm" variant="success" @click="add_pattern">
              등록
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="10">표시되는 개수 : 기본 10개</option>
              <option value=15>15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template>
            <template slot="is_alive" slot-scope="row">
              <b-badge v-if="row.item.is_del" variant="danger">삭제</b-badge>
              <b-badge v-else :variant="row.item.is_alive ? 'success' : 'secondary'">{{row.item.is_alive ? 'On' : 'Off'}}</b-badge>
            </template>
            <template slot="category" slot-scope="row">{{row.item.category ? (codes.code_category[row.item.category] || row.item.category) : '-'}}</template>
            <template slot="ext" slot-scope="row">{{row.item.ext ? (codes.code_ext[row.item.ext] || row.item.ext) : '-' }}</template>
            <!-- type 은 꼭 있어야 함 -->
            <template slot="type" slot-scope="row">{{row.item.type ? codes.code_type[row.item.type] : '-'}}</template>
            <template slot="code" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.code | truncate(50) }}</del>
              <span v-else>
                <span v-if="row.item.code">{{row.item.code | truncate(50) }}</span>
                <span v-else>-</span>
              </span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>